

const $9acb9dd1918652f7$export$d861e1d90b30ff64 = {
    Practice: 1,
    Qualification: 2,
    Quarterfinals: 3,
    Semifinals: 4,
    Finals: 5,
    RoundOf16: 6,
    TopN: 15,
    RoundRobin: 16
};
const $9acb9dd1918652f7$export$7f4c6ae6cd2bdde3 = {
    V5RC: 1,
    VURC: 4,
    WORKSHOP: 37,
    VIQRC: 41,
    NRL: 43,
    ADC: 44,
    TVRC: 46,
    TVIQRC: 47,
    VRAD: 51,
    BellAVR: 55,
    FAC: 56,
    VAIRC: 57
};
const $9acb9dd1918652f7$export$6fda41c7fb23acf9 = [
    "2024-2025",
    "2023-2024",
    "2022-2023",
    "2021-2022",
    "2020-2021",
    "2019-2020",
    "2018-2019",
    "2017-2018",
    "2016-2017",
    "2015-2016",
    "2014-2015",
    "2013-2014",
    "2012-2013",
    "2011-2012",
    "2010-2011",
    "2009-2010"
];
const $9acb9dd1918652f7$export$a11931ae0aed9c69 = {
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.V5RC]: {
        "2024-2025": 190,
        "2023-2024": 181,
        "2022-2023": 173,
        "2021-2022": 154,
        "2020-2021": 139,
        "2019-2020": 130,
        "2018-2019": 125,
        "2017-2018": 119,
        "2016-2017": 115,
        "2015-2016": 110,
        "2014-2015": 102,
        "2013-2014": 92,
        "2012-2013": 85,
        "2011-2012": 73,
        "2010-2011": 7,
        "2009-2010": 1
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.VURC]: {
        "2024-2025": 191,
        "2023-2024": 182,
        "2022-2023": 175,
        "2021-2022": 156,
        "2020-2021": 140,
        "2019-2020": 131,
        "2018-2019": 126,
        "2017-2018": 120,
        "2016-2017": 116,
        "2015-2016": 111,
        "2014-2015": 103,
        "2013-2014": 93,
        "2012-2013": 88,
        "2011-2012": 76,
        "2010-2011": 10,
        "2009-2010": 4
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.WORKSHOP]: {
        "2024-2025": 118,
        "2015-2016": 113,
        "2014-2015": 107,
        "2013-2014": 98
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.VIQRC]: {
        "2024-2025": 189,
        "2023-2024": 180,
        "2022-2023": 174,
        "2021-2022": 155,
        "2020-2021": 138,
        "2019-2020": 129,
        "2018-2019": 124,
        "2017-2018": 121,
        "2016-2017": 114,
        "2015-2016": 109,
        "2014-2015": 101,
        "2013-2014": 96
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.NRL]: {
        "2019-2020": 137
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.ADC]: {
        "2024-2025": 192,
        "2023-2024": 184,
        "2022-2023": 176,
        "2021-2022": 158,
        "2020-2021": 144,
        "2019-2020": 134
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.TVRC]: {
        "2023-2024": 187,
        "2022-2023": 179,
        "2021-2022": 167,
        "2020-2021": 142,
        "2019-2020": 136
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.TVIQRC]: {
        "2023-2024": 186,
        "2022-2023": 178,
        "2021-2022": 166,
        "2020-2021": 141,
        "2019-2020": 135
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.FAC]: {
        "2023-2024": 188,
        "2022-2023": 177,
        "2021-2022": 165
    },
    [$9acb9dd1918652f7$export$7f4c6ae6cd2bdde3.VAIRC]: {
        "2024-2025": 194,
        "2023-2024": 185,
        "2021-2022": 171
    }
};


// settings & const
const $e77a975a36b2bd87$var$DEFAULT_HEADERS = {
    "Content-Type": "application/json"
};
const $e77a975a36b2bd87$var$PATH_PARAM_RE = /\{[^{}]+\}/g;
/** Add custom parameters to Request object */ class $e77a975a36b2bd87$var$CustomRequest extends Request {
    constructor(input, init){
        super(input, init);
        // add custom parameters
        for(const key in init)if (!(key in this)) this[key] = init[key];
    }
}
function $e77a975a36b2bd87$export$ddcec56dc3db7f2c() {
    return Math.random().toString(36).slice(2, 11);
}
function $e77a975a36b2bd87$export$2e2bcd8739ae039(clientOptions) {
    let { baseUrl: baseUrl = "", fetch: baseFetch = globalThis.fetch, querySerializer: globalQuerySerializer, bodySerializer: globalBodySerializer, headers: baseHeaders, ...baseOptions } = {
        ...clientOptions
    };
    baseUrl = $e77a975a36b2bd87$export$b6d465111d914331(baseUrl);
    baseHeaders = $e77a975a36b2bd87$export$eee1781d075786ae($e77a975a36b2bd87$var$DEFAULT_HEADERS, baseHeaders);
    const middlewares = [];
    /**
   * Per-request fetch (keeps settings created in createClient()
   * @param {T} url
   * @param {import('./index.js').FetchOptions<T>} fetchOptions
   */ async function coreFetch(schemaPath, fetchOptions) {
        const { baseUrl: localBaseUrl, fetch: fetch = baseFetch, headers: headers, params: params = {}, parseAs: parseAs = "json", querySerializer: requestQuerySerializer, bodySerializer: bodySerializer = globalBodySerializer ?? $e77a975a36b2bd87$export$75a86642fb2d79a0, ...init } = fetchOptions || {};
        if (localBaseUrl) baseUrl = $e77a975a36b2bd87$export$b6d465111d914331(localBaseUrl);
        let querySerializer = typeof globalQuerySerializer === "function" ? globalQuerySerializer : $e77a975a36b2bd87$export$db5dd4577326922e(globalQuerySerializer);
        if (requestQuerySerializer) querySerializer = typeof requestQuerySerializer === "function" ? requestQuerySerializer : $e77a975a36b2bd87$export$db5dd4577326922e({
            ...typeof globalQuerySerializer === "object" ? globalQuerySerializer : {},
            ...requestQuerySerializer
        });
        const requestInit = {
            redirect: "follow",
            ...baseOptions,
            ...init,
            headers: $e77a975a36b2bd87$export$eee1781d075786ae(baseHeaders, headers, params.header)
        };
        if (requestInit.body !== undefined) {
            requestInit.body = bodySerializer(requestInit.body);
            // remove `Content-Type` if serialized body is FormData; browser will correctly set Content-Type & boundary expression
            if (requestInit.body instanceof FormData) requestInit.headers.delete("Content-Type");
        }
        let id;
        let options;
        let request = new $e77a975a36b2bd87$var$CustomRequest($e77a975a36b2bd87$export$da8b2e6360cc2092(schemaPath, {
            baseUrl: baseUrl,
            params: params,
            querySerializer: querySerializer
        }), requestInit);
        if (middlewares.length) {
            id = $e77a975a36b2bd87$export$ddcec56dc3db7f2c();
            // middleware (request)
            options = Object.freeze({
                baseUrl: baseUrl,
                fetch: fetch,
                parseAs: parseAs,
                querySerializer: querySerializer,
                bodySerializer: bodySerializer
            });
            for (const m of middlewares)if (m && typeof m === "object" && typeof m.onRequest === "function") {
                const result = await m.onRequest({
                    request: request,
                    schemaPath: schemaPath,
                    params: params,
                    options: options,
                    id: id
                });
                if (result) {
                    if (!(result instanceof Request)) throw new Error("onRequest: must return new Request() when modifying the request");
                    request = result;
                }
            }
        }
        // fetch!
        let response = await fetch(request);
        // middleware (response)
        // execute in reverse-array order (first priority gets last transform)
        if (middlewares.length) for(let i = middlewares.length - 1; i >= 0; i--){
            const m = middlewares[i];
            if (m && typeof m === "object" && typeof m.onResponse === "function") {
                const result = await m.onResponse({
                    request: request,
                    response: response,
                    schemaPath: schemaPath,
                    params: params,
                    options: options,
                    id: id
                });
                if (result) {
                    if (!(result instanceof Response)) throw new Error("onResponse: must return new Response() when modifying the response");
                    response = result;
                }
            }
        }
        // handle empty content
        // note: we return `{}` because we want user truthy checks for `.data` or `.error` to succeed
        if (response.status === 204 || response.headers.get("Content-Length") === "0") return response.ok ? {
            data: {},
            response: response
        } : {
            error: {},
            response: response
        };
        // parse response (falling back to .text() when necessary)
        if (response.ok) {
            // if "stream", skip parsing entirely
            if (parseAs === "stream") return {
                data: response.body,
                response: response
            };
            return {
                data: await response[parseAs](),
                response: response
            };
        }
        // handle errors
        let error = await response.text();
        try {
            error = JSON.parse(error); // attempt to parse as JSON
        } catch  {
        // noop
        }
        return {
            error: error,
            response: response
        };
    }
    return {
        /** Call a GET endpoint */ GET (url, init) {
            return coreFetch(url, {
                ...init,
                method: "GET"
            });
        },
        /** Call a PUT endpoint */ PUT (url, init) {
            return coreFetch(url, {
                ...init,
                method: "PUT"
            });
        },
        /** Call a POST endpoint */ POST (url, init) {
            return coreFetch(url, {
                ...init,
                method: "POST"
            });
        },
        /** Call a DELETE endpoint */ DELETE (url, init) {
            return coreFetch(url, {
                ...init,
                method: "DELETE"
            });
        },
        /** Call a OPTIONS endpoint */ OPTIONS (url, init) {
            return coreFetch(url, {
                ...init,
                method: "OPTIONS"
            });
        },
        /** Call a HEAD endpoint */ HEAD (url, init) {
            return coreFetch(url, {
                ...init,
                method: "HEAD"
            });
        },
        /** Call a PATCH endpoint */ PATCH (url, init) {
            return coreFetch(url, {
                ...init,
                method: "PATCH"
            });
        },
        /** Call a TRACE endpoint */ TRACE (url, init) {
            return coreFetch(url, {
                ...init,
                method: "TRACE"
            });
        },
        /** Register middleware */ use (...middleware) {
            for (const m of middleware){
                if (!m) continue;
                if (typeof m !== "object" || !("onRequest" in m || "onResponse" in m)) throw new Error("Middleware must be an object with one of `onRequest()` or `onResponse()`");
                middlewares.push(m);
            }
        },
        /** Unregister middleware */ eject (...middleware) {
            for (const m of middleware){
                const i = middlewares.indexOf(m);
                if (i !== -1) middlewares.splice(i, 1);
            }
        }
    };
}
class $e77a975a36b2bd87$var$PathCallForwarder {
    constructor(client, url){
        this.client = client;
        this.url = url;
    }
    GET(init) {
        return this.client.GET(this.url, init);
    }
    PUT(init) {
        return this.client.PUT(this.url, init);
    }
    POST(init) {
        return this.client.POST(this.url, init);
    }
    DELETE(init) {
        return this.client.DELETE(this.url, init);
    }
    OPTIONS(init) {
        return this.client.OPTIONS(this.url, init);
    }
    HEAD(init) {
        return this.client.HEAD(this.url, init);
    }
    PATCH(init) {
        return this.client.PATCH(this.url, init);
    }
    TRACE(init) {
        return this.client.TRACE(this.url, init);
    }
}
class $e77a975a36b2bd87$var$PathClientProxyHandler {
    constructor(){
        this.client = null;
    }
    // Assume the property is an URL.
    get(coreClient, url) {
        const forwarder = new $e77a975a36b2bd87$var$PathCallForwarder(coreClient, url);
        this.client[url] = forwarder;
        return forwarder;
    }
}
function $e77a975a36b2bd87$export$7635eeb3e012a2cf(coreClient) {
    const handler = new $e77a975a36b2bd87$var$PathClientProxyHandler();
    const proxy = new Proxy(coreClient, handler);
    // Put the proxy on the prototype chain of the actual client.
    // This means if we do not have a memoized PathCallForwarder,
    // we fall back to the proxy to synthesize it.
    // However, the proxy itself is not on the hot-path (if we fetch the same
    // endpoint multiple times, only the first call will hit the proxy).
    function Client() {}
    Client.prototype = proxy;
    const client = new Client();
    // Feed the client back to the proxy handler so it can store the generated
    // PathCallForwarder.
    handler.client = client;
    return client;
}
function $e77a975a36b2bd87$export$290577a5816c1e9a(clientOptions) {
    return $e77a975a36b2bd87$export$7635eeb3e012a2cf($e77a975a36b2bd87$export$2e2bcd8739ae039(clientOptions));
}
function $e77a975a36b2bd87$export$8e146cb7ee7a6316(name, value, options) {
    if (value === undefined || value === null) return "";
    if (typeof value === "object") throw new Error("Deeply-nested arrays/objects aren\u2019t supported. Provide your own `querySerializer()` to handle these.");
    return `${name}=${options?.allowReserved === true ? value : encodeURIComponent(value)}`;
}
function $e77a975a36b2bd87$export$43d270033295e41a(name, value, options) {
    if (!value || typeof value !== "object") return "";
    const values = [];
    const joiner = {
        simple: ",",
        label: ".",
        matrix: ";"
    }[options.style] || "&";
    // explode: false
    if (options.style !== "deepObject" && options.explode === false) {
        for(const k in value)values.push(k, options.allowReserved === true ? value[k] : encodeURIComponent(value[k]));
        const final = values.join(","); // note: values are always joined by comma in explode: false (but joiner can prefix)
        switch(options.style){
            case "form":
                return `${name}=${final}`;
            case "label":
                return `.${final}`;
            case "matrix":
                return `;${name}=${final}`;
            default:
                return final;
        }
    }
    // explode: true
    for(const k in value){
        const finalName = options.style === "deepObject" ? `${name}[${k}]` : k;
        values.push($e77a975a36b2bd87$export$8e146cb7ee7a6316(finalName, value[k], options));
    }
    const final = values.join(joiner);
    return options.style === "label" || options.style === "matrix" ? `${joiner}${final}` : final;
}
function $e77a975a36b2bd87$export$ad3322bbc3b60542(name, value, options) {
    if (!Array.isArray(value)) return "";
    // explode: false
    if (options.explode === false) {
        const joiner = {
            form: ",",
            spaceDelimited: "%20",
            pipeDelimited: "|"
        }[options.style] || ","; // note: for arrays, joiners vary wildly based on style + explode behavior
        const final = (options.allowReserved === true ? value : value.map((v)=>encodeURIComponent(v))).join(joiner);
        switch(options.style){
            case "simple":
                return final;
            case "label":
                return `.${final}`;
            case "matrix":
                return `;${name}=${final}`;
            // case "spaceDelimited":
            // case "pipeDelimited":
            default:
                return `${name}=${final}`;
        }
    }
    // explode: true
    const joiner = {
        simple: ",",
        label: ".",
        matrix: ";"
    }[options.style] || "&";
    const values = [];
    for (const v of value)if (options.style === "simple" || options.style === "label") values.push(options.allowReserved === true ? v : encodeURIComponent(v));
    else values.push($e77a975a36b2bd87$export$8e146cb7ee7a6316(name, v, options));
    return options.style === "label" || options.style === "matrix" ? `${joiner}${values.join(joiner)}` : values.join(joiner);
}
function $e77a975a36b2bd87$export$db5dd4577326922e(options) {
    return function querySerializer(queryParams) {
        const search = [];
        if (queryParams && typeof queryParams === "object") for(const name in queryParams){
            const value = queryParams[name];
            if (value === undefined || value === null) continue;
            if (Array.isArray(value)) {
                search.push($e77a975a36b2bd87$export$ad3322bbc3b60542(name, value, {
                    style: "form",
                    explode: true,
                    ...options?.array,
                    allowReserved: options?.allowReserved || false
                }));
                continue;
            }
            if (typeof value === "object") {
                search.push($e77a975a36b2bd87$export$43d270033295e41a(name, value, {
                    style: "deepObject",
                    explode: true,
                    ...options?.object,
                    allowReserved: options?.allowReserved || false
                }));
                continue;
            }
            search.push($e77a975a36b2bd87$export$8e146cb7ee7a6316(name, value, options));
        }
        return search.join("&");
    };
}
function $e77a975a36b2bd87$export$8d266d20a1e70eef(pathname, pathParams) {
    let nextURL = pathname;
    for (const match of pathname.match($e77a975a36b2bd87$var$PATH_PARAM_RE) ?? []){
        let name = match.substring(1, match.length - 1);
        let explode = false;
        let style = "simple";
        if (name.endsWith("*")) {
            explode = true;
            name = name.substring(0, name.length - 1);
        }
        if (name.startsWith(".")) {
            style = "label";
            name = name.substring(1);
        } else if (name.startsWith(";")) {
            style = "matrix";
            name = name.substring(1);
        }
        if (!pathParams || pathParams[name] === undefined || pathParams[name] === null) continue;
        const value = pathParams[name];
        if (Array.isArray(value)) {
            nextURL = nextURL.replace(match, $e77a975a36b2bd87$export$ad3322bbc3b60542(name, value, {
                style: style,
                explode: explode
            }));
            continue;
        }
        if (typeof value === "object") {
            nextURL = nextURL.replace(match, $e77a975a36b2bd87$export$43d270033295e41a(name, value, {
                style: style,
                explode: explode
            }));
            continue;
        }
        if (style === "matrix") {
            nextURL = nextURL.replace(match, `;${$e77a975a36b2bd87$export$8e146cb7ee7a6316(name, value)}`);
            continue;
        }
        nextURL = nextURL.replace(match, style === "label" ? `.${encodeURIComponent(value)}` : encodeURIComponent(value));
    }
    return nextURL;
}
function $e77a975a36b2bd87$export$75a86642fb2d79a0(body) {
    if (body instanceof FormData) return body;
    return JSON.stringify(body);
}
function $e77a975a36b2bd87$export$da8b2e6360cc2092(pathname, options) {
    let finalURL = `${options.baseUrl}${pathname}`;
    if (options.params?.path) finalURL = $e77a975a36b2bd87$export$8d266d20a1e70eef(finalURL, options.params.path);
    let search = options.querySerializer(options.params.query ?? {});
    if (search.startsWith("?")) search = search.substring(1);
    if (search) finalURL += `?${search}`;
    return finalURL;
}
function $e77a975a36b2bd87$export$eee1781d075786ae(...allHeaders) {
    const finalHeaders = new Headers();
    for (const h of allHeaders){
        if (!h || typeof h !== "object") continue;
        const iterator = h instanceof Headers ? h.entries() : Object.entries(h);
        for (const [k, v] of iterator){
            if (v === null) finalHeaders.delete(k);
            else if (Array.isArray(v)) for (const v2 of v)finalHeaders.append(k, v2);
            else if (v !== undefined) finalHeaders.set(k, v);
        }
    }
    return finalHeaders;
}
function $e77a975a36b2bd87$export$b6d465111d914331(url) {
    if (url.endsWith("/")) return url.substring(0, url.length - 1);
    return url;
}


function $3936134e565e2d5f$export$5d730b7aed1a3eb0(options) {
    const base = (0, $e77a975a36b2bd87$export$2e2bcd8739ae039)({
        baseUrl: "https://www.robotevents.com/api/v2",
        headers: {
            Authorization: `Bearer ${options.authorization.token}`,
            ...options.request?.headers
        },
        ...options.request
    });
    // base.use({
    //   onRequest(options) {
    //     console.log("REQUEST", options);
    //   },
    //   onResponse(response) {
    //     console.log("RESPONSE", response);
    //   },
    // });
    const PaginatedGET = async (path, init)=>{
        let page = 1;
        let per_page = 250;
        let total = 0;
        let totalPages = 0;
        const data = [];
        const queryBase = init.params?.query ?? {};
        do {
            const request = await base.GET(path, {
                ...init,
                params: {
                    ...init.params,
                    query: {
                        ...queryBase,
                        page: page,
                        per_page: per_page
                    }
                }
            });
            if (request.error) return {
                response: request.response,
                error: request.error
            };
            const requestData = request.data;
            if (requestData.data) data.push(...requestData.data);
            if (requestData.meta) {
                total = requestData.meta.total ?? 0;
                totalPages = requestData.meta.last_page ?? 0;
            }
            const nextPageUrl = requestData.meta?.next_page_url;
            if (!nextPageUrl) break;
            const nextPage = new URL(nextPageUrl).searchParams.get("page");
            if (!nextPage) break;
            page = Number.parseInt(nextPage);
            if (!page || Number.isNaN(page)) break;
        }while (data.length < total && page <= totalPages);
        return {
            response: new Response(),
            data: data
        };
    };
    return {
        ...base,
        PaginatedGET: PaginatedGET
    };
}
async function $3936134e565e2d5f$export$3361e9be8093ddcc(response, transform) {
    const resp = await response;
    if (resp.error) return {
        response: resp.response,
        error: resp.error
    };
    if (!resp.data) return {
        response: resp.response,
        data: undefined,
        error: undefined
    };
    const data = await transform(resp.data, resp);
    return {
        response: resp.response,
        data: data,
        error: undefined
    };
}




class $6efda67d14943c52$export$f421feb8fad20413 {
    constructor(data){
        this.id = data.id;
        this.event = data.event;
        this.division = data.division;
        this.round = data.round;
        this.instance = data.instance;
        this.matchnum = data.matchnum;
        this.scheduled = data.scheduled;
        this.started = data.started;
        this.field = data.field;
        this.scored = data.scored;
        this.name = data.name;
        this.alliances = data.alliances;
    }
    id;
    event;
    division;
    round;
    instance;
    matchnum;
    scheduled;
    started;
    field;
    scored;
    name;
    alliances;
    getData() {
        return {
            id: this.id,
            event: this.event,
            division: this.division,
            round: this.round,
            instance: this.instance,
            matchnum: this.matchnum,
            scheduled: this.scheduled,
            started: this.started,
            field: this.field,
            scored: this.scored,
            name: this.name,
            alliances: this.alliances
        };
    }
    toJSON() {
        return this.getData();
    }
    /**
     * Gets the alliance with the given color
     *
     * @param color Red or Blue
     * @returns The alliance with the given color
     */ alliance(color) {
        return this.alliances.find((a)=>a.color === color);
    }
    /**
     * Gets the outcome of the match
     *
     * @example
     * const team = await robotevents.teams.get("3796B");
     * const matches = await team.matches();
     *
     * for (const match of match) {
     *  const { winner, loser } = match.allianceOutcome();
     *  console.log(winner.color, loser.color)
     * };
     *
     * @returns The winning and losing alliance, or null if the match is unscored or tied
     */ allianceOutcome() {
        const red = this.alliance("red");
        const blue = this.alliance("blue");
        if (red.score > blue.score) return {
            winner: red,
            loser: blue
        };
        else if (blue.score > red.score) return {
            winner: blue,
            loser: red
        };
        else return {
            winner: null,
            loser: null
        };
    }
    /**
     * Gets the outcome of the match for a specific team
     *
     * @param team Team number
     */ teamOutcome(team) {
        const { winner: winner, loser: loser } = this.allianceOutcome();
        if (!this.scored && !winner && !loser) return "unscored";
        if (!winner || !loser) return "tie";
        if (winner.teams.find((t)=>t.team?.name === team)) return "win";
        else if (loser.teams.find((t)=>t.team?.name === team)) return "loss";
        else return "tie";
    }
    /**
     * Gets all of the teams in the match, excludes non-sitting teams (i.e. teams on the alliance who
     * do not play, very rare in modern competitions)
     * @returns List of all teams in the match
     */ teams() {
        return this.alliances.flatMap((a)=>a.teams.filter((t)=>!t.sitting).map((t)=>t.team));
    }
    /**
     * Gets a short name for this match based on the round. Short name looks something like
     *
     * ```
     * P 13
     * Q 23
     * R16 1-1
     * QF 1-1
     * SF 2-1
     * F 1-3
     * F 3 // IQ finals matches
     * RR 2-1 // Round Robin
     * ```
     *
     */ shortName() {
        const id = this.instance + "-" + this.matchnum;
        switch(this.round){
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).Practice:
                return "P " + this.matchnum;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).Qualification:
                return "Q " + this.matchnum;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).Quarterfinals:
                return "QF " + id;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).Semifinals:
                return "SF " + id;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).Finals:
                return "F " + id;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).RoundOf16:
                return "R16 " + id;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).TopN:
                return "F " + this.matchnum;
            case (0, $9acb9dd1918652f7$export$d861e1d90b30ff64).RoundRobin:
                return "RR " + id;
            default:
                return this.name;
        }
    }
}



class $a0ffb3d740d9f211$export$d61e24a684f9e51 {
    client;
    constructor(data, client){
        this.client = client;
        this.id = data.id;
        this.sku = data.sku;
        this.name = data.name;
        this.start = data.start;
        this.end = data.end;
        this.season = data.season;
        this.program = data.program;
        this.location = data.location;
        this.locations = data.locations;
        this.divisions = data.divisions;
        this.level = data.level;
        this.ongoing = data.ongoing;
        this.awards_finalized = data.awards_finalized;
        this.event_type = data.event_type;
    }
    // Event Data
    id;
    sku;
    name;
    start;
    end;
    season;
    program;
    location;
    locations;
    divisions;
    level;
    ongoing;
    awards_finalized;
    event_type;
    getURL() {
        return `https://www.robotevents.com/${this.sku}.html`;
    }
    getData() {
        return {
            id: this.id,
            sku: this.sku,
            name: this.name,
            start: this.start,
            end: this.end,
            season: this.season,
            program: this.program,
            location: this.location,
            locations: this.locations,
            divisions: this.divisions,
            level: this.level,
            ongoing: this.ongoing,
            awards_finalized: this.awards_finalized,
            event_type: this.event_type
        };
    }
    toJSON() {
        return this.getData();
    }
    /**
     * Get teams at an event
     * @param query Team Search Options
     * @returns List of Teams
     */ teams(query, options) {
        return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(this.client.PaginatedGET("/events/{id}/teams", {
            params: {
                query: query,
                path: {
                    id: this.id
                }
            },
            ...options
        }), (data)=>data.map((team)=>new (0, $917fc2d03d21b9c5$export$3e5d0af8e738b082)(team, this.client)));
    }
    /**
     * Get skills runs at an event
     * @param query Query Params
     * @returns Array of skills runs
     */ skills(query, options) {
        return this.client.PaginatedGET("/events/{id}/skills", {
            params: {
                query: query,
                path: {
                    id: this.id
                }
            },
            ...options
        });
    }
    /**
     * Gets awards at an event
     * @param query Query Params
     * @returns Array of awards
     */ awards(query, options) {
        return this.client.PaginatedGET("/events/{id}/awards", {
            params: {
                query: query,
                path: {
                    id: this.id
                }
            },
            ...options
        });
    }
    /**
     * Gets matches for a division
     * @param division
     * @param query Query Params
     * @returns Array of matches
     */ matches(division, query, options) {
        return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(this.client.PaginatedGET("/events/{id}/divisions/{div}/matches", {
            params: {
                query: query,
                path: {
                    id: this.id,
                    div: division
                }
            },
            ...options
        }), (data)=>data.map((match)=>new (0, $6efda67d14943c52$export$f421feb8fad20413)(match)));
    }
    /**
     * Gets finalist rankings for a division (used in VIQRC)
     * @param division Division ID
     * @param query Query Params
     * @returns Array of finalist rankings
     */ finalistRankings(division, query, options) {
        return this.client.PaginatedGET("/events/{id}/divisions/{div}/finalistRankings", {
            params: {
                query: query,
                path: {
                    id: this.id,
                    div: division
                }
            },
            ...options
        });
    }
    /**
     * Gets rankings for a division
     * @param division Division ID
     * @param query Query Params
     * @returns List of rankings
     */ rankings(division, query, options) {
        return this.client.PaginatedGET("/events/{id}/divisions/{div}/rankings", {
            params: {
                query: query,
                path: {
                    id: this.id,
                    div: division
                }
            },
            ...options
        });
    }
}



class $917fc2d03d21b9c5$export$3e5d0af8e738b082 {
    client;
    constructor(data, client){
        this.client = client;
        this.id = data.id;
        this.number = data.number;
        this.team_name = data.team_name;
        this.robot_name = data.robot_name;
        this.organization = data.organization;
        this.location = data.location;
        this.registered = data.registered;
        this.program = data.program;
        this.grade = data.grade;
    }
    // Team Data
    id;
    number;
    team_name;
    robot_name;
    organization;
    location;
    registered;
    program;
    grade;
    /**
     * Gets the RobotEvents listing for the team
     */ getURL() {
        return `https://www.robotevents.com/teams/${this.program.code}/${this.number}`;
    }
    /**
     * Returns the raw response from RobotEvents
     */ getData() {
        return {
            id: this.id,
            number: this.number,
            team_name: this.team_name,
            robot_name: this.robot_name,
            organization: this.organization,
            location: this.location,
            registered: this.registered,
            program: this.program,
            grade: this.grade
        };
    }
    /**
     * Converts the team to JSON
     */ toJSON() {
        return this.getData();
    }
    /**
     * Get events the team has attended (or registered for)
     * @param query Query Params
     * @returns List of events
     */ events(query, options) {
        return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(this.client.PaginatedGET("/teams/{id}/events", {
            params: {
                path: {
                    id: this.id
                },
                query: query
            },
            ...options
        }), (data)=>data.map((event)=>new (0, $a0ffb3d740d9f211$export$d61e24a684f9e51)(event, this.client)));
    }
    /**
     * Get matches the team has played
     * @param query Query Params
     * @returns List of matches
     */ matches(query, options) {
        return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(this.client.PaginatedGET("/teams/{id}/matches", {
            params: {
                path: {
                    id: this.id
                },
                query: query
            },
            ...options
        }), (data)=>data.map((match)=>new (0, $6efda67d14943c52$export$f421feb8fad20413)(match)));
    }
    /**
     * Get rankings for the team
     * @param query Query Params
     * @returns List of rankings
     */ rankings(query, options) {
        return this.client.PaginatedGET("/teams/{id}/rankings", {
            params: {
                path: {
                    id: this.id
                },
                query: query
            },
            ...options
        });
    }
    /**
     * Get skills runs for the team
     * @param query Query Params
     * @returns List of skills runs
     */ skills(query, options) {
        return this.client.PaginatedGET("/teams/{id}/skills", {
            params: {
                path: {
                    id: this.id
                },
                query: query,
                ...options
            }
        });
    }
    /**
     * Get awards the team has won
     * @param query Query Params
     * @returns List of awards
     */ awards(query, options) {
        return this.client.PaginatedGET("/teams/{id}/awards", {
            params: {
                path: {
                    id: this.id
                },
                query: query
            },
            ...options
        });
    }
}







function $516574956edfdcc4$export$1c3913303fb07225(client) {
    return {
        /**
         * Get a list of events
         * @param query Event Search Options
         * @param options Request Options, passed to fetch
         * @returns Paginated List of Events
         */ async search (query, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.PaginatedGET("/events", {
                params: {
                    query: query
                },
                ...options
            }), (data)=>data.map((event)=>new (0, $a0ffb3d740d9f211$export$d61e24a684f9e51)(event, client)));
        },
        /**
         * Get an event by ID
         * @param id Event ID (not SKU)
         * @returns Event
         */ async get (id, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.GET("/events/{id}", {
                params: {
                    path: {
                        id: id
                    }
                },
                ...options
            }), (data)=>new (0, $a0ffb3d740d9f211$export$d61e24a684f9e51)(data, client));
        },
        /**
         * Get an event by SKU
         * @param id Event SKU
         * @returns Event
         */ async getBySKU (sku, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.GET("/events", {
                params: {
                    query: {
                        "sku[]": [
                            sku
                        ]
                    }
                },
                ...options
            }), (data)=>{
                const event = data.data?.[0];
                return event ? new (0, $a0ffb3d740d9f211$export$d61e24a684f9e51)(event, client) : null;
            });
        }
    };
}



function $cb5e0a054b6da7b0$export$fa6583def7f6260f(client) {
    return {
        ...(0, $9acb9dd1918652f7$export$7f4c6ae6cd2bdde3),
        /**
         * Get details about a program
         * @param id Program ID
         * @returns Details about the program
         */ async get (id, options) {
            return client.GET("/programs/{id}", {
                params: {
                    path: {
                        id: id
                    }
                },
                ...options
            });
        },
        /**
         * Get a list of programs
         * @param options Query Params
         * @returns List of programs
         */ async all (query, options) {
            return client.PaginatedGET("/programs", {
                params: {
                    query: query
                },
                ...options
            });
        }
    };
}





function $a7b31c40fa394592$export$ce51f5e5fe0ec64a(client) {
    return {
        ...(0, $9acb9dd1918652f7$export$a11931ae0aed9c69),
        /**
         * Get details about a season
         * @param id Season ID
         * @returns Details about the season
         */ async get (id, options) {
            return client.GET("/seasons/{id}", {
                params: {
                    path: {
                        id: id
                    }
                },
                ...options
            });
        },
        /**
         * Get a list of seasons
         * @param options Query Params
         * @returns List of seasons
         */ async all (query, options) {
            return client.PaginatedGET("/seasons", {
                params: {
                    query: query
                },
                ...options
            });
        },
        /**
         * Get events for a season
         * @param id Season ID
         * @returns List of events
         **/ async events (id, query, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.PaginatedGET("/seasons/{id}/events", {
                params: {
                    path: {
                        id: id
                    },
                    query: query
                },
                ...options
            }), (data)=>data.map((event)=>new (0, $a0ffb3d740d9f211$export$d61e24a684f9e51)(event, client)));
        }
    };
}




function $61d9fd3d0c651a77$export$a6dd4deab0761294(client) {
    return {
        /**
         * Get team by their ID (not number)
         * @param id Team ID
         * @returns Team
         **/ async get (id, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.GET("/teams/{id}", {
                params: {
                    path: {
                        id: id
                    }
                },
                ...options
            }), (data)=>new (0, $917fc2d03d21b9c5$export$3e5d0af8e738b082)(data, client));
        },
        /**
         * Get a list of teams
         * @param options Query Params
         * @returns List of teams
         **/ async search (query, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.PaginatedGET("/teams", {
                params: {
                    query: query
                },
                ...options
            }), (data)=>data.map((team)=>new (0, $917fc2d03d21b9c5$export$3e5d0af8e738b082)(team, client)));
        },
        /**
         * Get Team by Number
         * @param number Team Number
         * @param program Program Code
         * @param options Request Options
         * @returns Team
         */ async getByNumber (number, program, options) {
            return (0, $3936134e565e2d5f$export$3361e9be8093ddcc)(client.PaginatedGET("/teams", {
                params: {
                    query: {
                        "number[]": [
                            number
                        ],
                        "program[]": [
                            program
                        ]
                    }
                },
                ...options
            }), (data)=>data.length > 0 ? new (0, $917fc2d03d21b9c5$export$3e5d0af8e738b082)(data[0], client) : null);
        }
    };
}


function $e9d20890320694b8$export$1f2bb630327ac4b6(options) {
    const client = (0, $3936134e565e2d5f$export$5d730b7aed1a3eb0)(options);
    const events = (0, $516574956edfdcc4$export$1c3913303fb07225)(client);
    const programs = (0, $cb5e0a054b6da7b0$export$fa6583def7f6260f)(client);
    const seasons = (0, $a7b31c40fa394592$export$ce51f5e5fe0ec64a)(client);
    const teams = (0, $61d9fd3d0c651a77$export$a6dd4deab0761294)(client);
    return {
        api: client,
        events: events,
        programs: programs,
        seasons: seasons,
        teams: teams
    };
}


const $e73bf42412feb220$var$teamId = 122732;
function $e73bf42412feb220$var$getSearchDate() {
    const now = new Date();
    const searchUTC = new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate() + 10));
    return searchUTC.toISOString().slice(0, 10);
}
const $e73bf42412feb220$var$client = (0, $e9d20890320694b8$export$1f2bb630327ac4b6)({
    authorization: {
        token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiMGJmMTdkZmIxZWRjMmRlZGQ5MjhmM2ZkODEzZDNkNWM1ZjNjOGU3OTUwY2JhYTIzODA5YzIwNzM3OGE4ZmFjZTZiMGIyODdlMjdmODM4NjIiLCJpYXQiOjE2OTE5ODQ4MDMuMDAyNTA3OSwibmJmIjoxNjkxOTg0ODAzLjAwMjUxMSwiZXhwIjoyNjM4NzU5NjAyLjk5NzEyOTksInN1YiI6IjExNzQzOSIsInNjb3BlcyI6W119.opzagy4WRMMhh3LQQhk0Fp-2NGo37AushuMGtU4cS6VwkxhsL-YdEzq18x1ocXLxj_Ip_1J41dL3NaVgCDUkrHZRA2eR-taKXKh7OZo3W-s9PJJjGKb4RyolAIPUWiQzQKdzbbKsvXoqdFAK8zfiEE_jjMIww9eXEEzd_COI2FtIp4BBgR84ss_RsuLWcT9r0OjW810iZTBzep96KwJPQDatq6RXTMIpc04HZcYUJah1l4hAjQlpReER4CKQ7w5IdPXzdOS1He-eToEwpIKTPXKoxnAcnwdOQWiJj3RAXFf9lVM5n9s7K-OdSMTBS3LKDlzxfJHAYQwC0Wpdr4LnMol4LcyZksyVXu-bb-vxxYeYm88ziIsLeCef0l9qHf_D46_jfln2e8cpaK88VBkKQmQO3gI8PB-QY4h0hGWwO3-WLV2vR_8TwwAoaw9Hds02NCKNNRzMI7ShqRyonjcTn5O1t2BwSrwnOVDTUGYf5EFWIjEbGB8B-xuqfCFqtq9u8kzeFqszgAUzdYOomsdjB35U5mWP7shOm4HRUm5I6OEmUTu5NZnRHLP8vZpIdS1_81WT2wCdyB6qxfIn3SuJk44EklLPzN4H6KkVH74j6J5d8CkB--NY74WyQVHapmGo4Dr9siIjg4am6w2nqYjbi3zVGxSk_aBYM5PoMDHnATY"
    }
});
const $e73bf42412feb220$var$eventsSelect = document.getElementById("events");
const $e73bf42412feb220$var$divisionsSelect = document.getElementById("divisions");
$e73bf42412feb220$var$eventsSelect.addEventListener("change", (event)=>{
    const eventId = event.target.value;
    $e73bf42412feb220$var$loadDivisions(eventId);
});
$e73bf42412feb220$var$divisionsSelect.addEventListener("change", (event)=>{
    const divisionId = event.target.value;
    $e73bf42412feb220$var$loadTeams(divisionId);
});
const $e73bf42412feb220$var$thresholdInput = document.getElementById("threshold");
let $e73bf42412feb220$var$threshold = parseFloat($e73bf42412feb220$var$thresholdInput.value);
$e73bf42412feb220$var$thresholdInput.addEventListener("input", (event)=>{
    $e73bf42412feb220$var$threshold = parseFloat(event.target.value);
    $e73bf42412feb220$var$loadTeams(parseInt($e73bf42412feb220$var$eventsSelect.value), parseInt($e73bf42412feb220$var$divisionsSelect.value));
});
const $e73bf42412feb220$var$teamsTableBody = document.getElementById("teams").querySelector("tbody");
const $e73bf42412feb220$var$teamsCache = {};
async function $e73bf42412feb220$var$loadEvents() {
    const season = await $e73bf42412feb220$var$client.seasons.all({
        "program[]": [
            $e73bf42412feb220$var$client.programs.V5RC
        ],
        active: true
    });
    const events = await $e73bf42412feb220$var$client.events.search({
        "team[]": [
            $e73bf42412feb220$var$teamId
        ],
        "season[]": [
            season.data[0].id
        ],
        end: $e73bf42412feb220$var$getSearchDate()
    });
    for (const event of events.data){
        const option = document.createElement("option");
        option.value = event.id;
        option.text = `${event.name} - ${new Date(event.start).toLocaleDateString("en-US")}`;
        $e73bf42412feb220$var$eventsSelect.appendChild(option);
    }
    if (events.data.length > 0) $e73bf42412feb220$var$loadDivisions(events.data[0].id);
}
async function $e73bf42412feb220$var$loadDivisions(eventId) {
    const event = await $e73bf42412feb220$var$client.events.get(eventId);
    $e73bf42412feb220$var$divisionsSelect.innerHTML = "";
    for (const division of event.data.divisions){
        const option = document.createElement("option");
        option.value = division.id;
        option.text = division.name;
        $e73bf42412feb220$var$divisionsSelect.appendChild(option);
    }
    if (event.data.divisions.length > 0) $e73bf42412feb220$var$loadTeams(eventId, event.data.divisions[0].id);
}
async function $e73bf42412feb220$var$loadTeams(eventId, divisionId) {
    $e73bf42412feb220$var$teamsCache[eventId] = $e73bf42412feb220$var$teamsCache[eventId] ?? {};
    let matchData = $e73bf42412feb220$var$teamsCache[eventId][divisionId];
    if (!$e73bf42412feb220$var$teamsCache[eventId][divisionId]) {
        matchData = {};
        const event = await $e73bf42412feb220$var$client.events.get(eventId);
        const matches = await event.data.matches(divisionId);
        for (const match of matches.data){
            for (const alliance of match.alliances)for (const team of alliance.teams)$e73bf42412feb220$var$updateStats(matchData, team.team.name, alliance.score);
        }
        const keys = Object.keys(matchData);
        keys.sort((a, b)=>matchData[b].mean - matchData[a].mean);
        matchData.sortedKeys = keys;
        $e73bf42412feb220$var$teamsCache[eventId][divisionId] = matchData;
    }
    $e73bf42412feb220$var$displayTeams(matchData);
}
// https://math.stackexchange.com/questions/2148877/iterative-calculation-of-mean-and-standard-deviation
function $e73bf42412feb220$var$updateStats(cache, teamName, allianceScore) {
    cache[teamName] = cache[teamName] ?? {
        n: 0,
        s1: 0,
        s2: 0
    };
    let { n: n, s1: s1, s2: s2 } = cache[teamName];
    n++;
    s1 += allianceScore;
    s2 += allianceScore * allianceScore;
    const mean = s1 / n;
    const stddev = Math.sqrt(s2 / n - Math.pow(s1 / n, 2));
    cache[teamName] = {
        n: n,
        s1: s1,
        s2: s2,
        mean: mean,
        stddev: stddev
    };
}
async function $e73bf42412feb220$var$displayTeams(data) {
    $e73bf42412feb220$var$teamsTableBody.innerHTML = "";
    for (const teamName of data.sortedKeys){
        const stats = data[teamName];
        const row = document.createElement("tr");
        const cellNumber = document.createElement("td");
        const cellMean = document.createElement("td");
        const cellStddev = document.createElement("td");
        cellStddev.style.backgroundColor = `hsl(${Math.exp(Math.log(120) - stats.stddev / 10)}, 100%, 50%)`;
        cellNumber.textContent = teamName;
        cellMean.textContent = (stats.mean - $e73bf42412feb220$var$threshold).toFixed(2);
        cellStddev.textContent = stats.stddev.toFixed(2);
        row.appendChild(cellNumber);
        row.appendChild(cellMean);
        row.appendChild(cellStddev);
        $e73bf42412feb220$var$teamsTableBody.appendChild(row);
    }
}
$e73bf42412feb220$var$loadEvents();


//# sourceMappingURL=index.b75d8fae.js.map
